import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9010Handlers = [
  // KYMW9010関連会社一覧
  http.post(
    PlessService.SERVICE.getAssociatedCompanyList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getAssociatedCompanyList);
      // return ResponseUtils.getSysError();
    }
  ),

  // KYMW0400取引先一覧（動作確認時使用)
  http.post(
    PlessService.SERVICE.getSupplierList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getSupplierList);
    }
  ),
];

// 関連会社一覧
const getAssociatedCompanyList = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      AssociatedCompanyList: [
        {
          AssociatedCompanyId: "000001",
          AssociatedCompanyName: "あいうえお制作会社",
          TradeStopDivName: "通常",
        },
        {
          AssociatedCompanyId: "000002",
          AssociatedCompanyName: "かきくけこ制作会社",
          TradeStopDivName: "中止",
        },
        {
          AssociatedCompanyId: "000003",
          AssociatedCompanyName: "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９",
          TradeStopDivName: "廃止",
        },
        {
          AssociatedCompanyId: "000004",
          AssociatedCompanyName: "髙、﨑",
          TradeStopDivName: "通常",
        },
        {
          AssociatedCompanyId: "000005",
          AssociatedCompanyName: "たちつてと制作会社",
          TradeStopDivName: "中止",
        },
      ]
    }
  }
}

// 取引先一覧（動作確認時使用)
const getSupplierList = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
          SupplierCode: "100205",
          SupplierNameKanji: "アートナップ",
          TradeStopDiv: "1       ",
          TradeStopDivName: "中止"
      },
      {
          SupplierCode: "958085",
          SupplierNameKanji: "アーネスト",
          TradeStopDiv: "0       ",
          TradeStopDivName: ""
      },
      {
          SupplierCode: "975036",
          SupplierNameKanji: "アーネスト（留型）",
          TradeStopDiv: "0       ",
          TradeStopDivName: ""
      },
      {
          SupplierCode: "956805",
          SupplierNameKanji: "アーバンフーズ",
          TradeStopDiv: "0       ",
          TradeStopDivName: ""
      },
      {
          SupplierCode: "966967",
          SupplierNameKanji: "アーバンフーズ（畜産２）",
          TradeStopDiv: "0       ",
          TradeStopDivName: ""
      },
      {
          SupplierCode: "370417",
          SupplierNameKanji: "アーベストフーズ",
          TradeStopDiv: "1       ",
          TradeStopDivName: "中止"
      },
      {
          SupplierCode: "598309",
          SupplierNameKanji: "アーバンフーズ",
          TradeStopDiv: "1       ",
          TradeStopDivName: "中止"
      },
    ]
  }
}